<template>
  <material-card title="Audit Trail">
    <v-data-table :loading="loading" class='audit_trail_table' :headers="headers" hide-actions :items="filteredItems">
      <template v-slot:items="props">
        <tr :class="{ odd: props.item.odd}">
          <td width=150>{{ props.item.action }}</td>
          <td width=250>{{ props.item.field_name }}</td>
          <td width=350>{{ props.item.prev_value }}</td>
          <td width=350>{{ props.item.value }}</td>
          <td width=250 class="text-xs-right">{{ props.item.account }}</td>
          <td width=250 class="text-xs-right">{{ new Date(props.item.datetime).toLocaleString() }}</td>
        </tr>
      </template>

      <template v-slot:headers>
          <tr>
            <th class="column" :style="{ width: `${header.width}px` }" :class='[`text-xs-${header.align || "left"}`]'
              v-for="header in headers" :key='header.value'>{{ header.text }}</th>
          </tr>
          <tr>
            <th class="column" v-for="header in headers" :key='header.value' :class='[`text-xs-${header.align || "left"}`, "pb-2"] '>
              <v-text-field
                class="pt-0"
                v-if="['account', 'field_name'].includes(header.value)"
                placeholder="Search"
                autocomplete="off"
                clearable
                density="compact"
                hide-details
                variant="underlined"
                color="success"
                v-model="localFilters[header.value]"
              />

              <template v-if="header.value==='datetime'">
                <input type="date" v-model="localFilters.start_date" /><br/>
                <input type="date" v-model="localFilters.end_date" />
              </template>
            </th>
          </tr>
        </template>

    </v-data-table>
  </material-card>
</template>

<script>
import { getList } from '@/api/base_api'
import $format from '../../utils/formatter'

export default {
  props: {
    entity: String,
    entity_id: [String, Number],
    fields: Array,
    filters: Object, 
    hideFields: [Array, Object]
  },
  data () {
    return {
      localFilters: { field_name: '', value: '', prev_value: '', account: '', start_date: '', end_date: '' },
      items: [],
      loading: true,
      odd: false,
      opened: false,
      headers: [
        { value: 'action', text: 'Action', width: 140, sortable: false },
        { value: 'field_name', text: 'Name', width: 150, sortable: false },
        { value: 'prev_value', text: 'Before', width: 150, sortable: false },
        { value: 'value', text: 'After', width: 10, sortable: false },
        { value: 'account', text: 'Account', width: 170, align: 'right', sortable: false },
        { value: 'datetime', text: 'Date Time', width: 160, align: 'right', sortable: false },
      ]
    }
  },
  mounted () {
    this._getData()
  },
  computed: {
    filteredItems () {
      return this.items.filter(i => {

        // field name
        if (this.localFilters.field_name && i.field_name && !i.field_name.toLocaleLowerCase().includes(this.localFilters.field_name.toLocaleLowerCase())) {
          return false
        }

        // account 
        if (this.localFilters.account && i.account && !i.account.toLocaleLowerCase().includes(this.localFilters.account.toLocaleLowerCase())) {
          return false
        }

        if (this.localFilters.start_date && i.datetime < this.localFilters.start_date) {
          return false
        }

        if (this.localFilters.end_date && i.datetime > this.localFilters.end_date) {
          return false
        }

        return i
      })
    }
  },
  methods: {
    itemStyle (item) {
      return item.odd ? 'odd' : ''
    },
    _getFieldLabel(field_name) {
      return $format('field_name', field_name)
      // const field = this.fields.find(f => f.value === field_name)
      // return field_name
    },
    async _getData () {
      let res
      try {
        this.loading = true
        if (this.entity_id) {
          res = await getList(`audittrail/${this.entity}/${this.entity_id}`)
        } else {
          res = await getList(`audittrail/${this.entity}`, { filters: this.filters })
        }
      } catch (e) {
        this.items = []
        this.loading = false
        return
      }
      this.items = []
      for(const e of res.data) {
        this.items = this.items.concat(this._getChanges(e))
      }
      this.items=this.items.map((item)=>{
          if(["Spm","spm"].includes(item.action)){
            item.action="SPM"
          }
          item.field_name = item.field_name.replace(/spm/gi, "SPM");
          return item
        })

      //ISSUE 647
      if (this.items)
      {
        console.log(res.data)
        let jsonstr  = JSON.stringify(this.items)
        jsonstr = jsonstr.replaceAll('"Treatment"','"Drug"')
        jsonstr = jsonstr.replaceAll('"Last Administration"','"Admin date"')
        jsonstr = jsonstr.replaceAll('"Relationship"','"Investigator Relationship"')
        jsonstr = jsonstr.replaceAll('"Relationship Sponsor"','"Sponsor Relationship"')


        //ISSUE 644
        jsonstr = jsonstr.replaceAll('"Ae Verbatim Reported"','"AE Verbatim Reported"')
        jsonstr = jsonstr.replaceAll('"Meddra Llt Id"','"Lower Level Term ID"')
        jsonstr = jsonstr.replaceAll('"Meddra Pt Id"','"Preferred Term ID"')
        jsonstr = jsonstr.replaceAll('"Meddra Ae Lower Level Term"','"MedDRA AE Lower Level Term"')
        jsonstr = jsonstr.replaceAll('"Meddra Ae Preferred Term"','"MedDRA AE Preferred Term"')
        jsonstr = jsonstr.replaceAll('"Meddra System Organ Class"','"MedDRA System Organ Class"')
        jsonstr = jsonstr.replaceAll('"Meddra Version"','"MedDRA Version"')
        jsonstr = jsonstr.replaceAll('"Ae Onset Date"','"AE Onset Date"')
        jsonstr = jsonstr.replaceAll('"Ctcae Grade"','"CTCAE Grade"')
        jsonstr = jsonstr.replaceAll('"Evctm Reporting Date"','"EVCTM Reporting Date"')
        jsonstr = jsonstr.replaceAll('"Cro Triage"','"CRO Triage"')
        //ISSUE 644
        
        this.items = JSON.parse(jsonstr)
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].field_name.toLowerCase() === 'expectedness')          
          {
              //issue 647
              if ( this.items[i].value === '0' || this.items[i].value === 0)
              {
                this.items[i].value = 'Not Expected'
              }
              else if ( this.items[i].value === '1' || this.items[i].value === 1)
              {
                this.items[i].value = 'Expected'
              }
              else
              {
                this.items[i].value = ''
              }

              if ( this.items[i].prev_value === '0' || this.items[i].prev_value === 0)
              {
                this.items[i].prev_value = 'Not Expected'
              }
              else if ( this.items[i].prev_value === '1' || this.items[i].prev_value === 1)
              {
                this.items[i].prev_value = 'Expected'
              }
              else
              {
                this.items[i].prev_value = ''
              }
              //issue 647

          }
        }
      }
      //ISSUE 647
      this.loading = false
    },
    _getChanges (entry) {

      if (!entry.action) entry.action = ''
      if (!entry.action) entry.action = ''
      
      //ISSUE 644, rimosso protocol_id da quelli esclusi
      const ignore_fields = ['id', 'restore_pass_token', 'password', 'pregnancy_id', /*'protocol_id',*/ 'insert_at', 'adverse_event_id', 'external_unique_id', 'insertby_id' ]
      //ISSUE 644, rimosso protocol_id da quelli esclusi
      let changes = []
      for(const field_name in entry.fields) {
        
        if (ignore_fields.includes(field_name)) { continue }
    
        if (this.hideFields && this.hideFields[entry.entity] && this.hideFields[entry.entity].includes(field_name) ) {
          continue
        }
    
        let value
        let prev_value
    
        // se il campo e' una foreign
        if (entry.foreigns_map[field_name]) {
          value = $format(entry.foreigns_map[field_name], entry.foreigns[entry.foreigns_map[field_name]], 'audit_trail')
          prev_value = $format(entry.foreigns_map[field_name], entry.prev_foreigns[entry.foreigns_map[field_name]], 'audit_trail')
        } else {
          value = $format(field_name, entry.fields[field_name], field_name, 'audit_trail')
          prev_value = $format(field_name, entry.prev_fields[field_name], field_name, 'audit_trail')
        }
    
        //issue 656
        if (field_name === 'causality' && entry.entity === 'adverse_event')
        {
          if (value)
          {
            value = value.naranjo_answers.filter(x => x.value).map( (x) => { 
              if (x.value)
              {
                return x.name + ' -> ' + x.value 
              }
              else
              {
                return ''
              }
            }).join(" , ")
          }
          if (prev_value)
          {
              prev_value = prev_value.naranjo_answers.filter(x => x.value).map( (x) => { 
                if (x.value)
                {
                  return x.name + ' -> ' + x.value 
                }
                else
                {
                  return ''
                }
              }).join(" , ")
          }
        }
        //issue 656

        // se e' un PUT metto solo i valori nuovi
        const isEdit = entry.http_verb === 'PUT' || ['Confirm'].includes(entry.action)

        if (Array.isArray(value) && Array.isArray(prev_value)) {
             const equal = value.length === prev_value.length && value.every((value, index) => value === prev_value[index])
             if (equal) continue
        }
        if (value === prev_value && isEdit) continue

        // non lo metto se entrambi i valori sono vuoti
        if (!value &&  !prev_value) continue
    
        //issue delete
        if(entry.action.toLowerCase() === 'delete')
        {
          value = ''
        }
        if(entry.action.toLowerCase() === 'insert')
        {
          prev_value = ''
        }
        //issue delete

        const verbMap = {
          POST: 'Insert',
          PUT: 'Update',
          DELETE: 'Delete'
        }
        
        // const re = new RegExp(this.entity.replace('_has_', ' ').replace('_',' '), 'gi')
        changes.push({
          action: entry.action ? entry.action : verbMap[entry.http_verb],
          account: entry.insert_by,
          odd: this.odd,
          datetime: entry.insert_at,
          field_name: this._getFieldLabel(field_name),
          prev_value,
          color: entry.color,
          foreign: entry.entity !== this.entity,
          value
        })
      }
    
      // const re = new RegExp(this.entity.replace('_has_', ' ').replace('_',' '), 'gi')
      if (entry.http_verb === 'PUT' && !changes.length) {

        changes.push({
          action: entry.action, // ? `${entry.action || ''} ${entry.section || ''}`.replace(re, '') : verbMap[entry.http_verb] || '',
          account: entry.insert_by,
          datetime: (entry.insert_at),
          color: entry.color,
          odd: this.odd,
          field_name: 'EMPTY UPDATE'
        })
      }
    
      if (changes.length) {
        this.odd = !this.odd
      }
      return changes
    }
  }
}

</script>
<style>
.odd {
  background-color: beige;
}

.audit_trail_table .v-table__overflow {
  overflow-y: scroll;
  height: min(700px, 70vh);
}

.audit_trail_table td {
  word-wrap: anywhere;
}
</style>